import BusinessOffline from './BusinessOffline';

export default BusinessOffline;